module.exports = __webpack_public_path__ + "img/teresaIarocciMavica@2x.72fcd156.jpg";